// extracted by mini-css-extract-plugin
module.exports = {"bendingTable":"CuttingTable_bendingTable__2-jNf"};